import type { MDXComponents } from "mdx/types";

export function useMDXComponents(components: MDXComponents): MDXComponents {
  return {
    h1: ({ children }) => (
      <div className="ml-5 ">
        <h1 className="">{children}</h1>
      </div>
    ),
    ...components,
  };
}
